module.exports = __webpack_public_path__ + "static/logopng-76b7f042c2f4d46edfb5da724a955a5b.png";